import React from "react";

export default function Ccard() {
  return (
    <div className="communication-card">
      <div className="card-header">
        <div className="office-name">
          Abdullah bin Nasser bin Hamad Al Ateeq Office for Services
        </div>
      </div>

      <div className="button-group">
        <a href="https://wa.me/+9660535493047" className="btn whatsapp" target="_blank" rel="noopener noreferrer">
          WhatsApp <i className="fa fa-whatsapp" />
        </a>
        <a href="tel:+9660135817083" className="btn call">
          communication <i className="fa fa-phone" />
        </a>
      </div>
    </div>
  );
}
